import { spacing } from '../../theme/spacing';
import { lineHeight } from '../../theme/typography';

/**
 * Line-based min height for web multiline inputs when auto-sizing.
 * Defaults match `FormInput` multiline and the Vertiv form guide (`spacing` tokens).
 */
export const WEB_MULTILINE_MIN_H = spacing.formTextAreaMinHeightWeb;
export const WEB_MULTILINE_MAX_H = spacing.formTextAreaMaxHeightWeb;

export function estimateWebMultilineHeight(
  value: string,
  options: {
    min?: number;
    max?: number;
    lineHeight?: number;
    paddingV?: number;
  } = {},
): number {
  const min = options.min ?? WEB_MULTILINE_MIN_H;
  const max = options.max ?? WEB_MULTILINE_MAX_H;
  const lh = options.lineHeight ?? lineHeight.formControl;
  const paddingV = options.paddingV ?? spacing.formMultilineWebEstimatePaddingVertical;
  const lines = Math.max(1, String(value).split('\n').length);
  return Math.min(max, Math.max(min, lines * lh + paddingV));
}
